import * as ActionTypes from '../constants/ActionTypes';
import { assign } from 'lodash';

export const isUserLoggedIn = () => {
  return (dispatch, getState) => {
    return false;
  }
}

export const login = patient => {
  return (dispatch, getState) => {
    const payload = assign(getState().registration.toJS(), patient);

    dispatch({
      type: ActionTypes.LOGIN,
      payload: payload
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js